export default function registerLocale(vue_i18n) {
  const getLocaleFile = require.context("@/locale/", false, /\.json$/);

  getLocaleFile.keys().forEach(file => {
    const lang = file.slice(2).split(".")[0];
    const locale = getLocaleFile(file);

    vue_i18n.mergeLocaleMessage(lang, locale);
  });
}
